export const AppMessages = {
  login: {
    invalidPermission: 'You does not have the permission in this site. Please contact administrator for more information.'
  },
  errors: {
    required: 'The {0} is required.', // The <field name> is required.
    newPassSameOldPass: 'The new password must be different from the old password.',
    invalidPassPolicy: 'Your password does not meet the length or complexity requirements.',
    newPassNotMatchConfirmPass: 'New password and Confirm new password do not match.',
    invalidEmail: 'The Email is invalid.',
    isValidSurname: 'The Surname cannot contain special characters.',
    isValidFirstname: 'The Firstname cannot contain special characters.',
    isValidMiddleName: 'The Middlename cannot contain special characters.',
    invalidFile: 'Cannot upload this file, system only accepts these file extensions jpg, png, gif, svg, and the file size must be less than or equal to 2Mb.',
    invalidDocFile: 'Cannot upload this file, system only accepts these file extensions pdf, doc, docx, xls, xlsx, ppt, pptx, txt, jpg, png and the file size must be less than or equal to 2Mb.',
    invalidPdfFile: 'System only allows uploading pdf file extension, and the file size must be less than or equal to 2Mb.',
    invalidDate: 'Date is invalid format.',
    invalidRange: 'The value is out of integer range, valid range is {0} to {1}.',
    invalidDecimalRange: 'The valid range is {0} to {1}.',
    invalidCover: 'The valid range is from 0 to 2,147,483,647',
    invalidDateRangeWaitingRoom: 'Arrival To must be greater than Arrival From.',
    invalidDateRangeBooking: 'Return Date must be greater than Depart Date.',
    invalidMonthRangeWaitingRoom: 'The date range must be within 6 months.',
    invalidDateOfBirth: 'The date of birth must not be in future.',
    invalidDateOfLastMenstrualPeriod: 'The last menstrual period date must not be in future.',
    invalidDateOfAdministeredDate: 'The administered date must be in the past.',
    invalidDateAccountPayment: 'Date To must be greater than Date From.',
    invalidMinLength: 'Please enter at least 3 characters.',
    invalidDateRangeTripInfo: 'Return Date must be greater or equal to Depart Date.',
    invalidSpecialCharacters: 'The {0} cannot contain special character(s).',
    invalidTotalPayment: 'Total Entered must match Total Due.',
    invalidEmailDomain: 'The Email Domain is invalid.',
    invalidDateOfPast: 'The date of Administered must not be in past.',
    invalidExelFile: 'Cannot upload this file, system only accepts these file extensions xls, xlsx and the file size must be less than or equal to 2Mb.',
    invalidTime: 'End Time must be greater than Start Time.',
    invalidDuration: 'The time length between Start Time and End Time is less than the Duration.',
    invailidStartDate: 'End Time must be greater than Start Time.',
    sameNames: 'The staff has been added to the list. Please type in other name.',
    mdDatepickerMin: 'The {0} must not be in {1}.',
    // mdDatepickerMax: 'This field is larger than max date',
    errorCopyMasterData: 'The Copy Master Data is required. The selected centre must have the same currency as this centre.',
    maxDateFluVaccine: 'The selected date must not in the past or next 1 month.',
    invalidTripInfoDate: 'The date must not be in past.',
    // max: 'The value is out of integer range, valid range is {0} to {1}.',
    // min: 'The value is out of integer range, valid range is {0} to {1}.'
  },
  success: {
    changePass: 'Your password has been changed.'
  },
  dialog: {
    successTitle: 'Confirmation Message',
    errorTitle: 'Error Message',
    yesButton: 'Yes',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    saveButton: 'Save',
    createMessage: 'The content has been created successfully.',
    updateMessage: 'The content has been update successfully.',
    confirmMessage: 'Are you sure you want to remove {0}?',
    confirmMessage1:  'Are you sure you want to remove this item?',
    publishMessage: 'Are you sure you want to publish this memo?',
    unpublishMessage: 'Are you sure you want to un-publish this memo?'
  },
  user: {
    removeUser: 'Are you sure you want to remove this user from the centre?',
    disableUser: 'Are you sure you want to disable this user?',
    enableUser: 'Are you sure you want to enable this user?',
    resendActiveLinkUser: 'Are you sure you want to resend active link to this user?'
  },
  centre: {
    noUserAssigned: 'There is no user assigned to this centre.',
    removeUser: 'Are you sure you want to remove this user from the centre?',
    inactiveCentre: 'You are currently not assigned to any active centre. Please contact the administator for assistance.',
    confirmDisablePatient: 'Are you sure you want to disable this user?',
    confirmEnablePatient: 'Are you sure you want to enable this user?'
  },
  list: {
    noRecord: 'No Record',
    total: 'item(s)'
  },
  consultant: {
    errorSearch: 'Please enter at least one search criteria.',
    createMessage: 'Group is created successfully.',
    updateMessage: 'Group is updated successfully.',
    errorPrintOption: 'Please select at least 1 print option.'
  },
  individualConsultant: {
    removeUser: 'Are you sure you want to remove this patient from waiting room?'
  },
  groupConsultant: {
    confirmMessage: 'Are you sure you want to remove?',
    errorAddPatientStatus: 'Cannot add patient {0} to group. Patient must have the “Consultation” status, and not in any group.',
    errorAddPatient: 'Please Select Patient',
    removeGroup: 'Are you sure you want to dismiss this group (all patients need to take individual consultation)?',
    removeUserFromeExistedGroup: 'Are you sure you want to remove patient from group or group consultation (all group recommendations are stored)?',
    removeUserFromCreateGroup: 'Are you sure you want to remove patient from group?'
  },
  groupTemplateConsultant: {
    removeGroupTemplate: 'Are you sure you want to remove this group template, all the assigned patient(s) will change group name to Individual?',
    removeAttachment: 'Are you sure you want to remove this file?'
  },
  processConsultant: {
    removeDisease: 'Are you sure you want to remove the recommended disease?'
  },
  payment: {
    successAllocate: 'Credit note is allocated to invoice successfully.',
    errorAddFullyPaid: 'You cannot add credit note to fully paid invoice. Please select another invoice.',
    errorAddCreditNote: 'Please select a specific invoice to allocate the credit note.',
    errorAddCreditNoteValue: 'The credit note amount must be less than or equal to the invoice oustanding amount.',
    errorInvoicePaid: 'This invoice has been paid.',
    errorAddOrder: 'Please select the invoice(s).',
    errorAddOrderForCN: 'System cannot add order number to credit note.',
    errorWithholdTax: 'Withhold Tax amount cannot be larger than Amount Open',
    errorWithholdTaxType: 'Withhold Tax amount must be a positive number.',
    successPay: 'You have paid the invoice successfully.',
    errorOverPay: 'The current paid amount must be less than or equal to the outstanding amount. Please input the paid amount again.',
    errorPayValue: 'Payment value must be a positive number.',
    errorPay: 'Please select 1 invoice only',
		errorMergeInvoice: 'Please select invoice to view merge invoice report.',
    errorNotMatch: `"{0}" must match "{1}"`,
    errorRefund: 'The refund amount must be less than or equal to the invoice total.',
    addSuccess: 'Add {0} successfully',
    errorSaveRequired: 'The Withholding Tax, Reg No, Security of invoice {0} are required.'
  },
  patient: {
    removePatient: 'Are you sure you want to remove this patient account?',
    checkedDeceased: 'System does not send any email, or message to this patient. Do you want to continue?',
    addSameEmail: 'This email address is already in use. Are you sure to use the email address for a new account?'
  },
  waitingRoom: {
    confirmAddPatient: 'The patient can be added to the selected centre waiting room.',
    addPatientSuccess: 'The patient has been added to waiting room.'
  },
  prescribeVaccine: {
    errorPastDate: 'Vaccine schedule must not be the past date. Please select another date for visit date {0}.',
    errorCheckDate: 'Please select the date for visit date {0}.',
    errorSelectDate: 'The visit date is after the depart date',
    errorSelectVaccine: '{0} is already in schedule',
    errorNumberOfVaccine: 'Please type in number of administered vaccine.',
    errorVisitDateAccending: 'Visit Dates must be in ascending order.',
    errorMacthDate: `
    Course schedule

    Part 1
    Beside each vaccine is a required number.
    This indicates how many visits you need to schedule for that vaccine.
    E.g. If it says 2, you must select 2 checkboxes along that line, each checkbox denoting a visit.

    Part 2
    You must select a date for each visit on the course schedule.
    You can select a date by clicking on each textbox and selecting a date from the calendar.
    You can also use the date buttons, simply click on the textbox you wish to fill and then click the appropriate date button.`
  },

  disease: {
    removeDisease: 'Are you sure you want to remove this disease?',
    errorSelectData: `
    Please make a selection for each disease.

    Covered: The patient is currently covered for this disease and so does not require a vaccine at this time.
    Accept: You want to schedule the patient for a course of vaccination for this disease.
    Decided Against: You have made the patient aware of this vaccination but they have decided against it.

    You must make a selection for each disease.
    `
  },

  vaccine: {
    removeVaccine: 'Are you sure you want to remove this vaccine?',
    minDate: 'the past and current date',
    notBeNegative: 'Vaccine batch count cannot be negative number.'
  },

  supplier: {
    removeSupplier: 'Are you sure you want to remove this supplier?'
  },

  medicalCondition: {
    errorCheckPregnancy: 'Please answer pregnancy question.',
    removeMedicalCondition: 'Are you sure you want to remove this medical condition?',
    removeMedicalConditionCategory: 'Are you sure you want to remove this medical condition category?',
    addDuplicateCondition: 'The medical condition {0} has been added to the selected list.'
  },

  price: {
    removePrice: 'Are you sure you want to remove this price?',
  },
  labTest: {
    removeLabTest: 'Are you sure you want to remove this lab test?',
    removeLabTestCategory: 'Are you sure you want to remove this lab test category?',
    finishGroup: 'This is the end of group consultation, next stage will be in individual',
    finishGroupTemplate: 'The group template has been saved successfully.',
    provideTestResult: 'Please provide test result(s) before proceeding'
  },

  product: {
    removeProduct: 'Are you sure you want to remove this product?',
    removeProductCategory: 'Are you sure you want to remove this product category?',
  },

  prescription: {
    removePrescription: 'Are you sure you want to remove this prescription?',
    removePrescriptionCategory: 'Are you sure you want to remove this prescription category?'
  },

  administerVaccine: {
    errorBatchNumber: 'Please Select Batch Number.',
    errorSelectPregnancy: 'Please answer pregnancy question.',
    errorSiteAdministerVaccine: 'Please select a site to administer for each vaccine.',
    confirmNextStep: 'Confirm Administer Vaccine',
    errorProposeAdministerDate: 'The Proposed Admin Date must be the same for all vaccines, and after the latest administered date.'
  },
  region: {
    removeRegion: 'Are you sure you want to remove this region?'
  },
  countriesDiseases: {
    removeCountriesDiseases: 'Are you sure you want to remove this countries - diseases?'
  },
  diseasesVaccine: {
    removeDiseasesVaccine: 'Are you sure you want to remove this diseases - vaccine?'
  },
  emailDomain: {
    removeEmailDomain: 'Are you sure you want to remove this email domain?'
  },
  ViewScheduleFull: {
    noAdministerVaccine: 'No available vaccine schedule for this consultation.',
    noLabtest: 'No lab test ordered for this consultation.'
  },
  bookingDetails: {
    statusCancelled : 'This booking will be hidden from both Exodus and patient’s My TMB. Are you sure you want to continue?',
    remove: 'Are you sure you want to remove the booking on this date?'
  },
  listMemberBooking: {
    errorViewCalendar : 'Please add patient to the booking, and select a main contact. Booking information will send to this patient.',
    errorBookAppointment : 'Please add more patient to the booking. Flu vaccine group must be more than 1 member.',
    errorTMBStaffBookAppointment: 'Please add TMB staff to the booking.',
    noMemberRecord: 'No member record',
    noStaffRecord: 'No staff record',
    totalMember: 'total  Member',
    totalStaff: 'total  Staff',
    addMemberSuccess: 'Patient is added to group successfully.',
    duplicateMember: 'This patient has been added to booking successfully. Please select another patient.',
    duplicateMembers: 'The patient {0} has been added the list.',
    noPatient: 'No patient found.',
    errorMemberGroup: 'The group booking requires more than 1 member. Please add more members to the group booking.',
    errorMemberIndividual: 'Individual booking cannot have multiple members.',
    errorAddPatientIndividual: 'System cannot add many patients for Individual booking.',
    uniquePatient: 'The First Name, Surname and Date of Birth must be unique.'
  },
  bookingCalendar: {
    changeDate: 'Are you sure you want to change the booking date time?',
    discardConfirm: 'You are in booking process, system will discard your booking when you leave this page. Do you want to continue?',
    bookingConfirm: 'Are you sure you want to make the booking in this time slot?'
  },
  manageUserPatient: {
    changeEmail: 'System will set this patient account to inactive and send the active link again.'
  },
  consultation: {
    removeConsultation: 'Are you sure you want to remove this consultation?'
  },
  report: {
    onlyCentre: 'You must select a single centre for the {0} report.'
  },
  consultationStatus: {
    clearConsultation: '<center>Are you sure you want to clear old consultation for patient<p><b>{0} - {1}</b>?</p></center>'
  },
  document: {
    isShared: `The document is shared to the patient.`,
    unShared: `The document is not shared to the patient.`,
    emailNotify: `<center>Email patient that there are new uploaded documents?</center>\n<center>Patient Email: <u><a href="mailto:{0}">{0}</a></u></center>`
  },
  center: {
    isSystemadmim: 'Please Select Copy Master Data.'
  },
  centremanagementfee: {
    errorRate: 'Centre management fee rate must be less than 100 and greater than 0.',
  }
};



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/constants/messages.ts